<template>
    <input  v-model="phone"  />
</template>
<script>
export default {
    props: ['value'],
    data() {
        return {
            proxy: ''
        }
    },
    computed: {
        phone: {
            get() {
                let value = this.proxy.replace(/\D+/igm,'').substr(0,11).replace(/^(\d{0,2})(\d{0,4})(\d{0,5})/igm,'($1) $2-$3').replace(/\D+$/, '');                
                return value;
            },
            set(value) {        
                this.proxy = value;                                      
                this.$emit('input', value.replace(/\D+/igm,'').substr(0,11));
            }
        }
    },
    watch: {
        value: {
            immediate: true,
            handler(value) {
                this.proxy = `${value}`.replace(/\D+/igm,'');
            }
        }
    }
}
</script>